import { render, staticRenderFns } from "./ChooseConferenceLayoutView.vue?vue&type=template&id=5bc1468c&scoped=true&"
import script from "./ChooseConferenceLayoutView.vue?vue&type=script&lang=js&"
export * from "./ChooseConferenceLayoutView.vue?vue&type=script&lang=js&"
import style0 from "./ChooseConferenceLayoutView.vue?vue&type=style&index=0&id=5bc1468c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc1468c",
  null
  
)

export default component.exports